import React, { useEffect, useMemo, useState } from 'react';
import { inject, observer } from 'mobx-react';
import { useIntl } from 'umi';
import classNames from 'classnames';
import { RootStore } from '@/models';
import s from './index.less';
import { Icon, Slider } from '@/components';
import { MainChannel } from '@/models/simultaneousInterpretation';

interface ModelState {
  RTCInstance?: RootStore['rtc'];
  simultaneous?: RootStore['simultaneousInterpretation'];
}

interface Props extends ModelState {
  next: () => void;
}

const SwitchChannel: React.FC<Props> = inject(({ store }) => {
  return {
    RTCInstance: store.rtc,
    simultaneous: store.simultaneousInterpretation,
  };
})(
  observer((props) => {
    const { simultaneous, next } = props;
    const { currentChannelItem, isMainChannel, isReceiveMainChannel, mainChannelVolume } =
      simultaneous || {};
    const { formatMessage } = useIntl();

    return (
      <div
        className={s.panel}
        onClick={(e) => {
          e.nativeEvent.stopImmediatePropagation();
        }}
      >
        <div className={s.block}>
          <div className={s.desc}>{formatMessage({ id: 'AUDIENCE_CHANNEL' })}</div>
          <div
            className={s.item}
            onClick={() => {
              next && next();
            }}
          >
            <div className={s.customLangIcon}>
              <span>{isMainChannel ? '主' : currentChannelItem?.iconWord}</span>
            </div>
            <span className={s.name}>{currentChannelItem?.languageName}</span>
            <Icon className={s.rightArrow} name="icon-a-16_outlined_right" />
          </div>
          {!isMainChannel && (
            <>
              <div className={s.line} />
              <div
                className={s.item}
                onClick={() => {
                  simultaneous?.receiveMainChannel(!simultaneous?.isReceiveMainChannel);
                }}
              >
                {isReceiveMainChannel ? (
                  <Icon className={s.check} name="icon-check" />
                ) : (
                  <span className={s.check} />
                )}
                <span className={s.name}>{formatMessage({ id: 'RECEIVE_MAIN_CHANNEL' })}</span>
              </div>
            </>
          )}
          {isReceiveMainChannel && !isMainChannel && (
            <>
              <div className={s.line} />
              <div className={s.desc}>{formatMessage({ id: 'MAIN_CHANNEL_VOICE' })}</div>
              <div className={s.voiceChange}>
                <Icon name="icon-speaker_on" className={s['voiceIcon']} />
                <Slider
                  tooltipVisible={false}
                  className={s.mainChannelVoiceSlider}
                  defaultValue={mainChannelVolume}
                  onChange={(val) => {
                    simultaneous?.setMainChannelVolume(val);
                  }}
                />
                <span className={s.voiceNum}>{mainChannelVolume}</span>
              </div>
            </>
          )}
        </div>
      </div>
    );
  })
);
export default SwitchChannel;
